import { render, staticRenderFns } from "./ReportRatingsSubject.vue?vue&type=template&id=76f446c3&scoped=true"
import script from "./ReportRatingsSubject.vue?vue&type=script&lang=js"
export * from "./ReportRatingsSubject.vue?vue&type=script&lang=js"
import style0 from "./ReportRatingsSubject.vue?vue&type=style&index=0&id=76f446c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f446c3",
  null
  
)

export default component.exports